import { render } from "./LearningTimer.vue?vue&type=template&id=4b541468"
import script from "./LearningTimer.vue?vue&type=script&lang=ts"
export * from "./LearningTimer.vue?vue&type=script&lang=ts"
script.render = render

export default script